import React from 'react';
import PropTypes from 'prop-types';
import '../Checkout/css/Checkout.css';
import {
  FIRST_NAME,
  LAST_NAME,
  DATE_OF_BIRTH,
  PASSPORT,
  SEX,
  PASSPORT_DATE_START,
  PASSPORT_DATE_END,
  AFTER_NANE,
  FIRST_NAME_PH,
  LAST_NAME_PH,
  AFTER_NAME_PH,
  DATE_PH,
  PASSPORT_PH,
  RUS_LETTERS_ERROR,
  LAT_LETTERS_ERROR,
  MALE_SEX,
  FEMALE_SEX,
  POSTAL_ADDRESS,
  POSTAL_ADDRESS_HINT,
  POST_INDEX,
  POST_INDEX_PH,
  CITY,
  CITY_PH,
  STREET,
  STREET_PH,
  HOUSE,
  HOUSE_PH,
  FLAT,
  FLAT_PH,
  ONLY_NUMBERS_POST_INDEX_ERROR,
} from '../../Utils/Constants/CheckoutConstants';
import {
  onlyRusLetters,
  passportSeriaAndNumber,
  onlyNumbers,
  rusAddress,
} from '../../Utils/ValidationUtil';
import Input from '../Input/Input';

// the buyer (contract) fields: checkout and the user cabinet
function BuyerForm(props) {
  const { contractInfo, handleChange, handleValid, handleSexChange } = props;

  const getSexClass = (sex) =>
    `ch_sex_button ${contractInfo.sex === sex ? 'ch_sex_selected' : ''}`;

  const renderPostalAddress = () => (
    <div className="ch_address_w">
      <div className="bm_text_18 mb_5">{POSTAL_ADDRESS}</div>
      <div className="gr_text_14 mb_20">{POSTAL_ADDRESS_HINT}</div>
      <div className="ch_inputs_w">
        <Input
          name="postIndex"
          label={POST_INDEX}
          placeholder={POST_INDEX_PH}
          value={contractInfo.postIndex}
          handleValueChange={handleChange}
          validation={onlyNumbers}
          validationError={ONLY_NUMBERS_POST_INDEX_ERROR}
          isValid={contractInfo.postIndexValid}
          isValidChange={handleValid}
          maxLength={6}
          required
        />
        <Input
          name="city"
          label={CITY}
          placeholder={CITY_PH}
          value={contractInfo.city}
          handleValueChange={handleChange}
          validation={rusAddress}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.cityValid}
          isValidChange={handleValid}
          required
          flex2
        />
      </div>
      <div className="ch_inputs_w">
        <Input
          name="street"
          label={STREET}
          placeholder={STREET_PH}
          value={contractInfo.street}
          handleValueChange={handleChange}
          validation={rusAddress}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.streetValid}
          isValidChange={handleValid}
          required
          flex2
        />
        <Input
          name="house"
          label={HOUSE}
          placeholder={HOUSE_PH}
          value={contractInfo.house}
          handleValueChange={handleChange}
          validation={rusAddress}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.houseValid}
          isValidChange={handleValid}
          maxLength={10}
          required
        />
        <Input
          name="flat"
          label={FLAT}
          placeholder={FLAT_PH}
          value={contractInfo.flat}
          handleValueChange={handleChange}
          validation={rusAddress}
          validationError={RUS_LETTERS_ERROR}
          maxLength={10}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="ch_inputs_w">
        <Input
          name="lastName"
          label={LAST_NAME}
          placeholder={LAST_NAME_PH}
          value={contractInfo.lastName}
          handleValueChange={handleChange}
          validation={onlyRusLetters}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.lastNameValid}
          isValidChange={handleValid}
          required
        />
        <Input
          name="firstName"
          label={FIRST_NAME}
          placeholder={FIRST_NAME_PH}
          value={contractInfo.firstName}
          handleValueChange={handleChange}
          validation={onlyRusLetters}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.firstNameValid}
          isValidChange={handleValid}
          required
        />
        <Input
          name="afterName"
          label={AFTER_NANE}
          placeholder={AFTER_NAME_PH}
          value={contractInfo.afterName}
          handleValueChange={handleChange}
          validation={onlyRusLetters}
          validationError={RUS_LETTERS_ERROR}
          isValid={contractInfo.afterNameValid}
          isValidChange={handleValid}
          required
        />
      </div>
      <div className="ch_inputs_w">
        <Input
          name="birthDay"
          label={DATE_OF_BIRTH}
          placeholder={DATE_PH}
          value={contractInfo.birthDay}
          type="date"
          handleValueChange={handleChange}
          isValid={contractInfo.birthDayValid}
          isValidChange={handleValid}
          required
        />
        <Input
          name="passport"
          label={PASSPORT}
          placeholder={PASSPORT_PH}
          value={contractInfo.passport}
          handleValueChange={handleChange}
          validation={passportSeriaAndNumber}
          validationError={LAT_LETTERS_ERROR}
          isValid={contractInfo.passportValid}
          isValidChange={handleValid}
          maxLength={9}
          required
        />
        <Input
          name="passportStartDate"
          label={PASSPORT_DATE_START}
          placeholder={DATE_PH}
          value={contractInfo.passportStartDate}
          handleValueChange={handleChange}
          type="date"
          isValid={contractInfo.passportStartDateValid}
          isValidChange={handleValid}
          required
        />
      </div>
      <div className="ch_inputs_w">
        <Input
          name="passportEndDate"
          label={PASSPORT_DATE_END}
          placeholder={DATE_PH}
          value={contractInfo.passportEndDate}
          handleValueChange={handleChange}
          type="date"
          isValid={contractInfo.passportEndDateValid}
          isValidChange={handleValid}
          required
          flex2
        />
        <div className="ch_sex_selector_w">
          <div className="from_label">
            <span className="gr_text_14">{SEX}</span>
            &nbsp;
            <span className="input_required">*</span>
          </div>
          <div className="ch_sex_slector_w">
            <button
              type="button"
              value="male"
              className={getSexClass('male')}
              onClick={() => handleSexChange('male')}
            >
              {MALE_SEX}
            </button>
            <button
              type="button"
              value="female"
              className={getSexClass('female')}
              onClick={() => handleSexChange('female')}
            >
              {FEMALE_SEX}
            </button>
          </div>
        </div>
      </div>
      {renderPostalAddress()}
    </>
  );
}

BuyerForm.propTypes = {
  contractInfo: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleValid: PropTypes.func.isRequired,
  handleSexChange: PropTypes.func.isRequired,
};

export default BuyerForm;
